import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { Subscription } from "rxjs";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { DetalleEstablecimientoService } from "../establecimiento/establecimiento.service";
import { DocumentoEntry } from "src/app/shared/entrys/documento.entry";
import { DetalleDocumentosService } from "../documentos/documentos.service";
import { environment } from "src/environments/environment";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { InformacionService } from "./imformacion.service";
import {InfoPago} from "src/app/shared/entrys/aciones-pago-fontur-rnt.entry";

@Component({
  selector: "app-informacion",
  templateUrl: "./informacion.component.html",
  styleUrls: ["./informacion.component.scss"],
})
export class InformacionComponent implements OnInit {
  id_pregunta_documento: number = 25;
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  suscripcion: Subscription;
  observaciones_prestador: string = null;
  observaciones: string = null;
  suspension = TipoSolicitud.Suspension;
  cancelacion = TipoSolicitud.Cancelacion;
  reactivacion = TipoSolicitud.Reactivacion;
  informacionEstablecimiento: any;
  documentos: Array<DocumentoEntry> = [];
  disponibilidad_documento: boolean = false;
  InformacionPago: InfoPago = {
    Texto_Informacion_pago_fontur: '',
    fecha_Ultima_Confirmacion_pago: ''
  };

  private AMAZON_IMAGEN;
  constructor(
    private dataSharedService: DataSharedService,
    private informacionService: InformacionService,
    private enviromentGlobalService: EnviromentGlobalService,
    private detalleDocumentosService: DetalleDocumentosService,
    private detalleEstablecimientoService: DetalleEstablecimientoService
  ) {
    this.suscripcion = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
    });

    this.informacionEstablecimiento = {};
    this.AMAZON_IMAGEN = enviromentGlobalService.amazonImage;
  }

  ngOnInit() {
    this.detalleEstablecimientoService
      .getDetalleEstablecimiento(this.datoSolicitudSharedModel.data)
      .subscribe((res) => {
        if (res.result) {
          this.informacionEstablecimiento = res.data;
          this.observaciones_prestador =
            this.informacionEstablecimiento.observaciones_prestador;
          this.observaciones = this.informacionEstablecimiento.observaciones;
        }
      });

   this.detalleDocumentosService
      .getDocumentos(this.datoSolicitudSharedModel.data)
      .subscribe( async(res) => {
        if (res.result) {
          this.documentos = res.data;
          this.verificarDisponibilidadDocumento();
          await this.InfoPagoFontur(this.datoSolicitudSharedModel.data.solicitud_id);
        }
      });
  }

  downloadFile(entry: DocumentoEntry) {
    this.informacionService
      .descargarDocumento({
        url: `${entry.ruta_url}/${entry.nombre_archivo}`,
      })
      .subscribe((resultado) => {
        const url = window.URL.createObjectURL(resultado);
        window.open(url);
      });
  }

  verificarDisponibilidadDocumento(): void {
    this.disponibilidad_documento = this.documentos.some(
      (documento: any) =>
        Array.isArray(documento.preguntas) &&
        documento.preguntas.some(
          (pregunta: any) => pregunta.nombre_archivo !== null
        )
    );
  }

  InfoPagoFontur(solicitud_id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.informacionService
        .getInFPagoFontur({ Solicitud_Id: solicitud_id })
        .subscribe(
          (result) => {
            if (result.data) {
              this.InformacionPago.Texto_Informacion_pago_fontur = result.data.mensaje_estado_pago_fontur;
              this.InformacionPago.fecha_Ultima_Confirmacion_pago= result.data.fecha_actualizacion_pago_multa_fontur
              resolve(this.InformacionPago); // Resolviendo la promesa con el valor deseado
            } else {
              resolve(null); // Resolver con null si no hay datos, o podrías manejarlo de otra forma
            }
          },
          (error) => {
            reject(error); // Rechazar la promesa en caso de error
          }
        );
    });
  }
}
